import AlertsContext from "common/providers/alerts";
import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import SpecyForm from "./SpecyForm";

function Specy() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem(
    "species",
    id,
    {}
  );

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate("/species");
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataSpecy: any) => {
      const newSpecy = { ...dataSpecy };

      try {
        if (newSpecy.id) {
          await updateItem(newSpecy.id, newSpecy);
        } else {
          await saveItem(newSpecy);
        }
      } catch (e: any) {
        return e;
      }
      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !item) ? null : (
    <SpecyForm onSubmit={onSubmit} specy={item} />
  );
}

export default Specy;
